import { useEffect } from "react";
import { useStrings } from "@/i18n/LocaleContext";

export function BuildingScreen({ durationMs, onDone }: { durationMs: number; onDone: () => void }) {
  const t = useStrings();
  useEffect(() => {
    const timer = setTimeout(onDone, durationMs);
    return () => clearTimeout(timer);
  }, [durationMs, onDone]);

  return (
    <div style={{ textAlign: "center", padding: "3rem 1rem" }} role="status" aria-live="polite">
      <div
        aria-hidden
        style={{
          width: 40,
          height: 40,
          margin: "0 auto 1rem",
          borderRadius: "50%",
          border: "3px solid var(--color-subtle)",
          borderTopColor: "var(--color-accent)",
        }}
      />
      <p style={{ fontFamily: "var(--font-title)", color: "var(--color-ink)" }}>{t.building}</p>
    </div>
  );
}
